import { api } from '@/api';
import { TEMPLATE_LIST_TAG } from '@/api/constants';
import { TemplateType } from './types';

/**
 * Deletes a template. `POST template/delete` taking `template_type` and
 * `template_id`, returning nothing. Callers refetch the list after a
 * successful delete so the table refreshes.
 */
export interface TemplateDeleteProps {
  templateType: TemplateType;
  templateId: string;
}

export type TemplateDeleteResponse = object;

const templateDeleteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postTemplateDelete: builder.query<TemplateDeleteResponse, TemplateDeleteProps>({
      query: ({ templateType, templateId }: TemplateDeleteProps) => ({
        url: `template/delete`,
        method: 'POST',
        body: {
          template_type: templateType,
          template_id: templateId,
        },
      }),
      // Refresh any cached list for this type (admin table + case download menus).
      async onQueryStarted({ templateType }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(api.util.invalidateTags([{ type: TEMPLATE_LIST_TAG, id: templateType }]));
        } catch (error) {
          console.error('Error in postTemplateDelete in onQueryStarted:', error);
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostTemplateDeleteQuery } = templateDeleteApi;
